import {
	CHANGE_TOKEN
} from "./actionTypes";

export const changeToken = token => ({
	type: CHANGE_TOKEN,
	payload: token
});
